import React from 'react'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { PlusOutlined } from '@ant-design/icons'

import { TabsLayout } from '@app/layouts'
import { Header, PermissionWrapper } from '@app/components'
import { CreateListModal } from '@app/modals'
import { LntButton } from '@app/components/base'

import { BUTTON_TYPE, SIZE } from '@app/constants'
import { PERMISSION } from '@app/constants/permission'

import { useToggle } from '@app/hooks'

import { createLists } from '@app/api/routes/monitoringLists'

import { MONITORINGS_LISTS_KEY } from '@app/constants/queryKeys'

import { CurrentListsTab, ArchivesListsTab } from './Tabs'

import type { CreateListsData } from '@app/api/routes/monitoringLists/types'
import type { TabsLayoutItem, TabToolbars } from '@app/layouts/TabsLayout/types'

const TABS_KEYS = {
  currentLists: 'currentLists',
  archivesLists: 'archivesLists'
} as const

const tabs: TabsLayoutItem[] = [
  {
    label: 'Текущие списки',
    key: TABS_KEYS.currentLists,
    content: <CurrentListsTab />
  },

  {
    label: 'Архивные списки',
    key: TABS_KEYS.archivesLists,
    content: <ArchivesListsTab />
  }
]

const title = 'Реестр списков'

export const RegistryPage: React.FC = () => {
  const {
    value: isCreateListModalOpen,
    setUntoggled: handleCloseCreateListModal,
    setToggled: handleOpenCreateListModal
  } = useToggle()

  const queryClient = useQueryClient()

  const createListMutation = useMutation({
    mutationFn: createLists,
    onSuccess: async () => await queryClient.invalidateQueries({ queryKey: [MONITORINGS_LISTS_KEY.currentListItems] })
  })

  const handleCreateList = (data: CreateListsData): void => {
    createListMutation.mutate(data, { onSettled: handleCloseCreateListModal })
  }

  const tabsSubheaderToolbars: TabToolbars = {
    [TABS_KEYS.currentLists]: [
      <PermissionWrapper
        requiredPermissions={ [PERMISSION.createAndCopyMonitoringList] }
        key='new-list-button'
      >
        <LntButton
          icon={ <PlusOutlined /> }
          type={ BUTTON_TYPE.primary }
          size={ SIZE.small }
          onClick={ handleOpenCreateListModal }
        >
          Новый список
        </LntButton>
      </PermissionWrapper>

      // TODO временно скрываем
      // <LntButton
      //   key="export-dropdown"
      //   type={ BUTTON_TYPE.primary }
      //   size={ SIZE.small }
      //   disabled
      // >
      //   Экспорт
      //   <Icon name={ ICON_NAME.arrowDown } />
      // </LntButton>,
    ]
  }

  return (
    <>
      <Header controlProps={ { title } } />

      <TabsLayout
        tabs={ tabs }
        tabToolbars={ tabsSubheaderToolbars }
      />

      <CreateListModal
        open={ isCreateListModalOpen }
        onCancel={ handleCloseCreateListModal }
        onCreateList={ handleCreateList }
      />
    </>
  )
}
